import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import { Box } from "../../atoms/Box";
import { Button } from "../../atoms/Button";

const ContactForm = () => {
  const [state, handleSubmit] = useForm("maylwrlz");
  if (state.succeeded) {
    return (
      <Box>
        <div className="bg-green-100 px-4 py-2 text-green-600 ring-1 ring-green-600 font-bold rounded-md">
          Thanks for signing up to my mailing list! I&apos;ll reach out as soon
          as I&apos;m ready for my next position.
        </div>
      </Box>
    );
  }
  return (
    <Box>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <div className="grid md:grid-cols-2  gap-4">
          <div className="flex flex-col">
            <label htmlFor="name" className="flex flex-col font-bold mb-2 mt-6">
              Name
            </label>
            <input
              id="name"
              type="text"
              name="name"
              className="px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>
          <div className="flex flex-col">
            <label
              htmlFor="email"
              className="flex flex-col font-bold mb-2 mt-6"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              name="email"
              className="px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
          </div>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="message"
            className="flex flex-col font-bold mb-2 mt-6"
          >
            Message
          </label>
          <textarea
            id="message"
            name="message"
            className="px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
          />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>
        <div className="mt-6 flex justify-center">
          <Button
            type="submit"
            disabled={state.submitting}
            onClick={(noop: unknown) => noop}
            className="group"
          >
            <div className="block headline group-hover:text-off-white">
              {state.submitting ? "Loading ..." : "Send Message"}
            </div>
          </Button>
        </div>
      </form>
    </Box>
  );
};

export { ContactForm };
